import { config } from '../../../../../config/config'
import api from '../../../../../api'

export const CREATE_LOGIN_PENDING = 'CREATE_LOGIN_PENDING'
export const CREATE_LOGIN_FULFILLED = 'CREATE_LOGIN_FULFILLED'
export const CREATE_LOGIN_REJECTED = 'CREATE_LOGIN_REJECTED'

export const CHANGE_LOGIN = 'CHANGE_LOGIN'

export function changeLogin(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_LOGIN, payload: { name, value } })
  }
}

export function createLoginAndToken(login, password) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: CREATE_LOGIN_PENDING });

    api({
      method: 'post',
      data: {
        query: `
          mutation createToken {
            createToken ( login: "${login}" password: "${password}" ) { 
              token 
            }
          }
          `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: CREATE_LOGIN_REJECTED, payload: errors });
        reject({ status: false, error: errors });
      } else {
        const { createToken } = data
        dispatch({ type: CREATE_LOGIN_FULFILLED, payload: createToken });
        localStorage.setItem(config.tokenKey, createToken.token);
        resolve({ status: true });
      }
    }).catch((errors) => {
      dispatch({ type: CREATE_LOGIN_REJECTED, errors });
      reject({ status: false, error: errors });
    });
  });
}

